export default __webpack_public_path__ + "static/media/FO.eba96e6c.svg";